<template>
  <div
    class="w-100 subnet-card"
    :class="{ 'selected-subnet': subnetData.subnetId === selectedSubnetIdx }"
    @click="onClickSelectSubnet(subnetData)"
  >
    <div class="subnet-address pl-1">
      <span class="subnet-topic--text">{{ subnetData.subnetAddress }}</span>
    </div>
    <div class="subnet-description pl-1">
      <b-badge
        pill
        :variant="badgeVariant(subnetData.ipVersion)"
        class="custom-badge-size"
      >
        {{ badgeIpAddress(subnetData.ipVersion) }}
      </b-badge>
      <span class="ml-1 subnet-description--text text-break">{{
        subnetData.subnetDescription
      }}</span>
    </div>
    <div class="subnet-tags">
      <div class="pl-1">
        <feather-icon class="text-primary" icon="TagIcon" size="14" />
        <b-badge
          v-for="(tag, index) in subnetData.tags"
          :key="index"
          variant="light-primary"
          class="custom-badge-size"
        >
          {{ tag }}
        </b-badge>
      </div>
    </div>
    <div
      v-if="isShowManageIcon"
      class="edit-icon"
      @click.stop="onClickEditSubnet(subnetData)"
    >
      <feather-icon icon="EditIcon" size="18" />
    </div>
    <div
      v-if="isShowManageIcon && hasDeletePermission"
      class="delete-icon"
      @click.stop="onClickDeleteSubnet(subnetData)"
    >
      <feather-icon icon="Trash2Icon" size="18" />
    </div>
  </div>
</template>

<script>
import { BBadge } from "bootstrap-vue"
import { IpVersionOptions } from "@/constants"
export default {
  name: "MoleculeSubnetCard",
  components: {
    BBadge,
  },
  emits: [
    "onSelectSubnetFromSidebar",
    "onRequestEditSubnet",
    "onRequestDeleteSubnet",
  ],
  props: {
    subnetData: {
      type: Object,
      required: true,
    },
    selectedSubnetIdx: {
      type: String,
      required: false,
      default: null,
    },
    hasManageIpAddressPermission: {
      type: Boolean,
      required: false,
      default: false,
    },
    hasDeletePermission: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    isShowManageIcon() {
      return (
        this.hasManageIpAddressPermission &&
        this.subnetData.subnetId === this.selectedSubnetIdx
      )
    },
  },
  methods: {
    badgeVariant(type) {
      if (type === 4) return "light-dark"
      else if (type === 6) return "light-info"
    },
    badgeIpAddress(type) {
      if (type === 4) return IpVersionOptions.IPV4
      else if (type === 6) return IpVersionOptions.IPV6
    },
    onClickSelectSubnet(subnetData) {
      this.$emit("onSelectSubnetFromSidebar", subnetData)
    },
    onClickEditSubnet(subnetData) {
      this.$emit("onRequestEditSubnet", subnetData)
    },
    onClickDeleteSubnet(subnetData) {
      this.$emit("onRequestDeleteSubnet", subnetData)
    },
  },
}
</script>

<style lang="scss" scoped>
.subnet-card {
  display: grid;
  grid-template-areas:
    " subnet-address edit-icon delete-icon"
    " subnet-description . ."
    " subnet-tags . .";
  grid-template-columns: auto 20px 20px;
  grid-gap: 6px;
  padding: 10px;
  transition: border 0.15s linear;
  margin-bottom: 6px;

  &:hover {
    cursor: pointer;
    background-color: #eeedfd;
  }
}

.selected-subnet {
  background-color: #eeedfd;
  border-left: 4px solid #7367f0;
  border-radius: 1.5px;

  .subnet-icon,
  .subnet-topic--text {
    color: #7367f0;
  }
}

.subnet-address {
  grid-area: subnet-address;
  display: flex;
  align-items: center;
  max-width: 24ch;
}

.edit-icon {
  grid-area: edit-icon;
  display: flex;
  align-items: center;
}

.delete-icon {
  grid-area: delete-icon;
  display: flex;
  align-items: center;
}

.subnet-description {
  grid-area: subnet-description;
}

.subnet-tags {
  grid-area: subnet-tags;
}

.subnet-topic--text {
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  word-break: break-all;
}

.subnet-description--text {
  font-weight: 400;
  font-size: 12px;
  line-height: 22px;
}

.custom-badge-size {
  font-size: 10px;
  margin-left: 5px;
}

// Small devices (landscape phones, 576px and up)
@media screen and (min-width: 576px) {
  .subnet-address {
    max-width: 100ch;
  }
}

// Medium devices (tablets, 768px and up)
@media screen and (min-width: 768px) {
}

// Large devices (desktops, 992px and up)
@media screen and (min-width: 992px) {
  .subnet-address {
    max-width: 24ch;
  }
}

// X-Large devices (large desktops, 1200px and up)
@media screen and (min-width: 1200px) {
}
</style>
